export default __webpack_public_path__ + "static/flag-lu-2b1c32322a499cd1e6ece42c8f4498f6.svg";